"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeMappingMenuComponent = void 0;
const core_1 = require("@angular/core");
const $ = require("jquery");
const size_mapping_menu_service_1 = require("./size-mapping-menu.service");
const notification_service_1 = require("./notification.service");
const size_service_1 = require("./size.service");
let SizeMappingMenuComponent = class SizeMappingMenuComponent {
    constructor(modalService, el, _af, _talk, _size) {
        this.modalService = modalService;
        this.el = el;
        this._af = _af;
        this._talk = _talk;
        this._size = _size;
        this.sizeMap = { "activated": true, "devices": [] };
        this.blank = [];
    }
    build() {
        this.element = $(this.el.nativeElement);
        this.sizeOptions = this._size.get();
        if (this.integration.sizeMapping) {
            this.minWidths = JSON.parse(this.integration.sizeMapping);
            this.minWidthNames = Object.keys(this.minWidths);
            let devices = this.adUnit.devices;
            let mappingCount = [];
            for (let device in devices) {
                if (devices[device].sizes.length > 0) {
                    mappingCount.push(devices[device].sizes);
                }
            }
            if (mappingCount.length > 0) {
                for (let name in this.minWidthNames) {
                    let key = this.minWidthNames[name];
                    let defMap = this.adUnit.sizeMapping.devices.filter(r => {
                        return r.deviceName == key;
                    });
                    this.sizeMap.devices.push({
                        "deviceName": defMap.deviceName,
                        "minWidth": defMap.minWidth,
                        "sizes": defMap.sizes
                    });
                }
            }
            if (this.adUnit.sizeMapping.devices.length > 0) {
                /*let devices = this.adUnit.sizeMapping.devices;
                for (let device in devices) {
                  if (this.minWidthNames.filter(r => {
                      return r == devices[device].deviceName
                    }).length == -1) {
                    this._talk.broadcast("A size mapping tier: " + devices[device].deviceName + " exists in this bidder file but no longer exists in your default settings.  This tier will be removed when you save this bidder file.");
                  }
                }*/
                this.sizeMap.devices = this.adUnit.sizeMapping.devices;
            }
            else if (this.sizeMap.devices.length < 1) {
                for (let name in this.minWidthNames) {
                    let key = this.minWidthNames[name];
                    this.sizeMap.devices.push({ "deviceName": key, "minWidth": this.minWidths[key], "sizes": [] });
                }
            }
            this.defaultSizes = this.adUnit.sizes;
        }
    }
    ngOnInit() {
        let modal = this;
        this.element = $(this.el.nativeElement);
        // ensure id attribute exists
        if (!this.id) {
            return;
        }
        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        this.element.appendTo('body');
        // close modal on background click
        this.element.on('click', function (e) {
            let target = $(e.target);
            //if (!target.closest('.modal-body').length) {
            //	modal.close();
            //}
        });
        // add self (this modal instance) to the modal service so it's accessible from controllers
        Promise.resolve(this.modalService.add(this)).then(r => {
            this.close();
        });
    }
    // remove self from modal service when directive is destroyed
    ngOnDestroy() {
        this.modalService.remove(this.id);
        this.element.remove();
    }
    // open modal
    open() {
        return Promise.resolve(this.build()).then(res => {
            this.element.show();
            $('#custom-modal-2').css('display', 'block');
            $('body').addClass('modal-open');
            this._af.tick();
            return true;
        });
    }
    // close modal
    close() {
        this.element.hide();
        $('#custom-modal-2').css('display', 'none');
        $('body').removeClass('modal-open');
    }
    limitSizes(sizes, minWidth) {
        return sizes.filter(s => {
            return (JSON.parse(s.name.match(/[^x]*/i)[0]) <= minWidth);
        });
    }
    addSizeMappingToUnit() {
        let mappingCheck = [];
        for (let device in this.sizeMap.devices) {
            if (this.sizeMap.devices[device].sizes.length > 0) {
                mappingCheck.push(this.sizeMap.devices[device].sizes);
            }
        }
        if (mappingCheck.length < 1) {
            return this._talk.broadcast("Sizes must be selected for at least one size tier in order to activate size mapping.");
        }
        if (this.defaultSizes.length < 1) {
            return this._talk.broadcast("At least one Default Size must be selected as a backup for Size Mapping");
        }
        this.sizeMap.activated = true;
        this.adUnit.sizeMapping = this.sizeMap;
        this._af.tick();
        this.close();
    }
};
exports.SizeMappingMenuComponent = SizeMappingMenuComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], SizeMappingMenuComponent.prototype, "id", void 0);
exports.SizeMappingMenuComponent = SizeMappingMenuComponent = __decorate([
    (0, core_1.Component)({
        moduleId: 'size-mapping-selector',
        selector: 'size-mapping-menu',
        template: `
    <div class="custom-modal">
      <div class="modal-body container-fluid">
        <div class="h3 text-center">
          Size Mapping
        </div>
        <div class="col-xs-4 text-center topPad30" *ngFor="let device of sizeMap.devices;let dev=index;">
          <div>
            <i class="fa fa-2x" [ngClass]="{'fa-desktop': (device.minWidth > 900), 'fa-tablet': (900 >= device.minWidth) && (device.minWidth >= 728), 'fa-mobile-phone':  (728 > device.minWidth) && (device.minWidth >= 300)}"></i>
          </div>
          <div>
           {{device.deviceName}} - Width: 
           <span class="bold" *ngIf="dev>0">{{sizeMap.devices[dev-1].minWidth}}px - </span>
           <span class="bold" *ngIf="dev==0"> > </span>
           <span class="bold">{{device.minWidth}}px</span> 
          </div>
          <div class="topMargin5">
            <ss-multiselect-dropdown class="whiteDropDown" *ngIf="dev>0" [options]="limitSizes(sizeOptions, sizeMap.devices[dev-1].minWidth)" id="sizes" [(ngModel)]="device.sizes"></ss-multiselect-dropdown>
            <ss-multiselect-dropdown class="whiteDropDown" *ngIf="dev==0" [options]="sizeOptions" id="sizes" [(ngModel)]="device.sizes"></ss-multiselect-dropdown>
          </div>    
        </div>
        <div class="row">
          <div class="col-xs-4 col-xs-offset-4 text-center topPad30">
            <div>
              <i class="fa fa-2x fa-th-large"></i>
            </div>
            <div>
             Default - All Widths
            </div>
            <div class="topMargin5">
              <ss-multiselect-dropdown class="whiteDropDown" [options]="sizeOptions" id="sizes" [(ngModel)]="defaultSizes"></ss-multiselect-dropdown>
            </div>    
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="custom-modal-close clickable" (click)="close('custom-modal-2');"><i class="fa fa-times" aria-hidden="true"></i></div>
        <div class="btn btn-default sizeMapping-close" (click)="close()">Cancel</div>
        <div class="btn btn-success sizeMapping-add" (click)="addSizeMappingToUnit()">Save Changes</div>
      </div>
    </div>
    <div class="modal-background" (click)="close('custom-modal-2');"></div>
  `
    }),
    __metadata("design:paramtypes", [size_mapping_menu_service_1.SizeMappingMenuService,
        core_1.ElementRef,
        core_1.ApplicationRef,
        notification_service_1.NotificationService,
        size_service_1.SizeService])
], SizeMappingMenuComponent);
//# sourceMappingURL=size-mapping-menu.component.js.map